module.exports = __webpack_public_path__ + "img/home-part-four-pic2.140160f2.png";